<template>
  <div>
    <h2 v-if="content.type == 'h2'" :id="content.text">{{ content.text }}</h2>
    <h3 v-if="content.type == 'h3'">{{ content.text }}</h3>
    <h4 v-if="content.type == 'h4'" v-html="$options.filters.fixParagraphText(content.text)"></h4>
    <p v-if="content.type == 'p'" v-html="$options.filters.fixParagraphText(content.text)"></p>
    <p v-if="content.type == 'link'" v-html="$options.filters.convertLink(content.text)"></p>
    <pre v-if="content.type == 'pre'" v-html="content.text"></pre>
    <p v-if="content.type == 'li'" v-html="$options.filters.convertBullet(content.text)"></p>
    <img v-if="content.type == 'img-logo'" :src="content.text" class="contentimg fr col-3 zoom" data-action="zoom">
    <img v-if="content.type == 'imgfl'" :src="content.text" class="contentimg fl col-6 zoom" data-action="zoom">
    <img v-if="content.type == 'imgfr'" :src="content.text" class="contentimg fr col-6 zoom" data-action="zoom">
    <img v-if="content.type == 'img'" :src="content.text" class="contentimg col-6 zoom" data-action="zoom">
  </div>
</template>

<script>
export default {
  name: 'MainContent',
  props: {
    'content': {
      type: Object,
      required: true
    }
  },
  // computed: {
  //   // contentList() {
  //   //   return this.$store.getters.getContentListPerformance;
  //   // }
  // },
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    },
    addNewLine: function (value) {
      return value.replace(/\r?\n/g, '<br>');
    },
    convertBullet: function (value) {
      return '<ul><li>' + value.replace(/\r?\n/g, '</li><li>') + '</li></ul>';
    },
    convertLink: function (value) {
      var lines = value.split(/\r\n|\n|\r/);
      if (lines.length < 2) return '';
      var line1 = lines[0];
      var line2 = lines[1];
      return '<a href="' + line1 + '">' + line2 + '</a>';
    },
    fixURLLink: function (value) {
      var regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
      var regexp_makeLink = function(all, url, h, href) {
        return '<a href="h' + href + '">' + url + '</a>';
      }
      value = value.replace(regexp_url, regexp_makeLink);
      return value;
    },
    fixParagraphText: function (value) {
      value = this.addNewLine(value);
      // value = this.fixURLLink(value);
      return value;
    },
  },
};
</script>

<style>
</style>
